var _g, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitCardYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 107,
    viewBox: "0 0 211 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_9533)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.800049,
    width: 209.6,
    height: 107,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.141 73.6463C241.524 67.6504 236.531 62.567 230.572 58.8149C224.613 55.0627 217.859 52.7492 210.865 52.0649C203.872 51.3805 196.839 52.3449 190.348 54.8786C183.856 57.4123 178.09 61.4428 173.525 66.6381C168.96 71.8335 165.727 78.045 164.092 84.7611C162.457 91.4771 162.466 98.5055 164.12 105.267C165.773 112.029 169.023 118.331 173.603 123.654C178.182 128.977 183.959 133.168 190.458 135.883L198.565 116.353C195.217 114.955 192.242 112.797 189.884 110.055C187.525 107.314 185.851 104.068 185 100.586C184.148 97.1033 184.143 93.4835 184.985 90.0246C185.828 86.5657 187.493 83.3666 189.844 80.6909C192.195 78.0152 195.164 75.9394 198.508 74.6345C201.851 73.3295 205.473 72.8329 209.075 73.1853C212.677 73.5378 216.155 74.7293 219.224 76.6617C222.293 78.5942 224.865 81.2122 226.727 84.3002L245.141 73.6463Z",
    fill: "#FFCE0E",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.417 23.2423C100.058 1.83642 107.054 -25.3398 128.042 -37.4575C149.031 -49.5752 176.064 -42.0456 188.423 -20.6397C200.781 0.766219 193.786 27.9425 172.797 40.0602C151.809 52.1778 124.775 44.6482 112.417 23.2423ZM169.992 -9.9988C163.627 -21.0233 149.704 -24.9012 138.895 -18.6604C128.085 -12.4195 124.482 1.57691 130.847 12.6014C137.212 23.626 151.135 27.5039 161.945 21.263C172.754 15.0221 176.357 1.02573 169.992 -9.9988Z",
    fill: "#FFCE0E",
    fillOpacity: 0.12
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.30005,
    y: 0.5,
    width: 208.6,
    height: 106,
    rx: 15.5,
    stroke: "url(#paint0_linear_571_9533)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.30005,
    y: 0.5,
    width: 208.6,
    height: 106,
    rx: 15.5,
    stroke: "#FFEFAF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_571_9533",
    x1: 9.50214,
    y1: 5.40019,
    x2: 199.667,
    y2: 114.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_9533"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.800049,
    width: 209.6,
    height: 107,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCardYellow);
export default __webpack_public_path__ + "static/media/benefitCardYellow.fe9d962c351747643a9d18217e125b0e.svg";
export { ForwardRef as ReactComponent };